import React, { useContext } from 'react';
import moment from 'moment';
import { useMediaQuery } from '@mui/material';
import AuthContext from '../../../hooks/authContext';
import { isSameDay } from 'date-fns';
import { filterAppointments } from '../../../services/helpers';
import styles from "../calendar.module.scss";
import { useNavigate } from 'react-router';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

const MonthView = (props) => {
  const isMobile = useMediaQuery('(max-width:767px)');
  const isFullScreen = useMediaQuery('(min-width:1500px)');
  const auth = useContext(AuthContext);
  const isExpand = auth.isExpanded;
  const appointments = auth.appointmentsData;
  const setIsModalOpen = auth.setIsModalOpen;
  const setSelectedAppointment = auth.setSelectedAppointment;
  const navigate = useNavigate();

  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const subtractMonth = (date) => new Date(date.getFullYear(), date.getMonth() - 1, 1);

  const redirectToAppointments = () => {
    navigate("/operations/appoinmentSchedule");
  }

  const getStatusTag = (cellData, emp, alerts) => {
    const timeZone = "America/New_York";
    const calendarTimezone = cellData?.calendarTimezone || timeZone;

    const currentDate = dayjs().tz(calendarTimezone).startOf("day");
    const appointmentDateTime = cellData?.datetime || cellData?.appointmentDateTime;
    const appointment = dayjs(appointmentDateTime).tz(calendarTimezone);
    const appointmentDay = appointment.clone().startOf("day");

    const isToday = appointmentDay.isSame(currentDate, "day");

    let status = styles.white;

    if (alerts === "allAlerts") {
      status = isToday ? styles.statusYellow : styles.fadYellow;
    } else if (alerts === "todayAlerts" && isToday) {
      status = styles.statusYellow;
    }

    const now = dayjs().tz(calendarTimezone);
    const minutesSinceAppointment = now.diff(appointment, "minute");

    if (cellData) {
      const timeSheetData = cellData;
      const secsToGet = timeSheetData?.checkInDateTime || timeSheetData?.createdAt;

      let seconds;
      if (secsToGet?.toJSON) {
        seconds = secsToGet.toJSON()["seconds"];
      } else if (secsToGet) {
        seconds = secsToGet["seconds"];
      }

      const checkIn = dayjs.unix(seconds).tz(calendarTimezone);
      const minutesLate = checkIn.diff(appointment, "minute");
      const now = moment();
      const isFuture = moment(appointmentDateTime).isAfter(now); 
      const hasCheckIn = !!timeSheetData?.checkInDateTime;

    if (!hasCheckIn) {
      if (isFuture) {
        status =
          alerts === "allAlerts"
            ? styles.statusYellow
            : alerts === "noAlerts"
            ? styles.white
            : alerts === "todayAlerts" && isToday
            ? styles.statusYellow
            : status;
      } else {
        status =
          alerts === "allAlerts"
            ? isToday
              ? styles.statusRed
              : styles.fadRed
            : alerts === "noAlerts"
            ? styles.white
            : alerts === "todayAlerts" && isToday
            ? styles.statusRed
            : status;
      }
    } else if (hasCheckIn && minutesLate <= 5) {
      status =
        alerts === "allAlerts"
          ? isToday
            ? styles.statusGreen
            : styles.fadGreen
          : alerts === "noAlerts"
          ? styles.white
          : alerts === "todayAlerts" && isToday
          ? styles.statusGreen
          : status;
    } else if (hasCheckIn && minutesLate > 5) {
      status =
        alerts === "allAlerts"
          ? isToday
            ? styles.statusOrange
            : styles.fadOrange
          : alerts === "noAlerts"
          ? styles.white
          : alerts === "todayAlerts" && isToday
          ? styles.statusOrange
          : status;
    }
  }
    return (
      <>
        <span style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
          <div className={`${styles.stausCircle} ${status} ${isMobile ? "mr-10" : ""}`}></div>
          <span style={{ wordBreak: "break-all" }}>
            <span className='clientTime dark:text-white'>{props?.settingsData?.timeFormat === "24hrs" ? moment(cellData.apoointmentDetails.time, 'h:mm A').format('HH:mm') : cellData.apoointmentDetails.time}</span> {" "}
            {emp && (
              <span className='clientLable dark:text-[#6B7280]'>
                {emp?.firstName}
              </span>
            )}
          </span>
        </span>
      </>
    );
  };

  const generateMonthView = () => {
    const daysInMonth = getDaysInMonth(props?.currentDate);
    const firstDay = getFirstDayOfMonth(props?.currentDate);
    const previousMonthDays = getDaysInMonth(subtractMonth(props?.currentDate));
    const totalCells = 42;

    const days = [];

    // const filteredAppointments = appointments.filter((item) =>
    //   props?.employeeNameList?.some((employee) => employee.value === item.userId)
    // );
    
    const getAppointmentsForDate = (date) => {
      if (!Array.isArray(appointments)) {
        return [];
      }

      return appointments.filter((appointment) => {
        const appointmentDate = new Date(appointment.apoointmentDetails.date);
        return isSameDay(appointmentDate, date);
      });
    };

    // Add previous month's dates
    for (let i = firstDay - 1; i >= 0; i--) {
      const date = moment(props?.currentDate).subtract(1, "month").date(previousMonthDays - i);
      const dayAppointments = getAppointmentsForDate(date);
      const isToday = date.isSame(moment(), 'day');
      const filterDayAppointments = filterAppointments(dayAppointments, props?.clientName, props?.empNames);
      const appointmentCount = filterAppointments(dayAppointments, props?.clientName, props?.empNames).length;
      days.push(
        <div key={`prev-${i}`} className={`calendar-day-null ${isToday ? 'bg-highlighBlue dark:bg-gray-600' : 'dark:bg-[#1A1F2C]'}`}
          style={{ cursor: filterDayAppointments?.length === 0 ? 'pointer' : 'default' }}>
          <div className={`appointmentDateCount ${isToday ? "dark:bg-gray-600" : "bg-white dark:bg-[#1A1F2C]"}`}>
            <div className={`calendar-day-number light-color ${isToday ? "dark:bg-gray-600" : "bg-white dark:bg-[#1A1F2C]"}`} style={{width : isExpand && isFullScreen ? "81%" : ""}}>{previousMonthDays - i}</div>
            <div className="appointmentCount" style={{width : isExpand && isFullScreen ? "19%" : ""}} onClick={() => props?.handleScrollToAppointments(date)}>
              {appointmentCount > 0 && (
                <span>
                  {appointmentCount} {!isMobile ? 'Appts' : ''}
                </span>
              )}
            </div>
          </div>
          {filterDayAppointments?.sort((a, b) => {
            const timeA = a.appointmentDateTime.slice(11, 16);
            const timeB = b.appointmentDateTime.slice(11, 16);
            return timeA.localeCompare(timeB);
          }).map((appointment, index) => {
            const emp = props?.employeeNameList?.find((emp) => emp.userId === appointment.userId);
            return (
              !isMobile ? (
                <div key={index} className="appointment" onClick={() => {
                  setSelectedAppointment(appointment);
                  setIsModalOpen(true);
                }}>
                  {getStatusTag(appointment, emp, props?.alerts)}
                </div>
              ) : null
            );
          })}
        </div>
      );
    }

    // Add current month's dates
    for (let day = 1; day <= daysInMonth; day++) {
      const date = moment(props?.currentDate).date(day);
      const dayAppointments = getAppointmentsForDate(date);
      const isToday = date.isSame(moment(), 'day');
      const filterDayAppointments = filterAppointments(dayAppointments, props?.clientName, props?.empNames);
      const appointmentCount = filterAppointments(dayAppointments, props?.clientName, props?.empNames).length;
      days.push(
        <div key={`current-${day}`} className={`calendar-day ${isToday ? 'bg-highlighBlue dark:bg-gray-600' : 'dark:bg-[#1A1F2C]'}`}
          style={{ cursor: filterDayAppointments?.length === 0 ? 'pointer' : 'default' }}>
          <div className={`appointmentDateCount ${isToday ? "dark:bg-gray-600" : "bg-white dark:bg-[#1A1F2C]"}`}>
            <div className={`calendar-day-number dark:text-white ${isToday ? "dark:bg-gray-600" : "bg-white dark:bg-[#1A1F2C]"}`} style={{width : isExpand && isFullScreen ? "81%" : ""}}>{day}</div>
            <div className="appointmentCount" style={{width : isExpand && isFullScreen ? "19%" : ""}} onClick={() => props?.handleScrollToAppointments(date)}>
              {appointmentCount > 0 && (
                <div>
                  {appointmentCount} {!isMobile ? 'Appts' : ''}
                </div>
              )}
            </div>
          </div>
          {filterDayAppointments?.sort((a, b) => {
            const timeA = a.appointmentDateTime.slice(11, 16);
            const timeB = b.appointmentDateTime.slice(11, 16);
            return timeA.localeCompare(timeB);
          }).map((appointment, index) => {
            const emp = props?.employeeNameList?.find((emp) => emp.userId === appointment.userId);
            return (
              !isMobile ? (
                <div key={index} className="appointment" onClick={() => {
                  setSelectedAppointment(appointment);
                  setIsModalOpen(true);
                }}>
                  {getStatusTag(appointment, emp, props?.alerts)}
                </div>) : null
            );
          })}
        </div>
      );
    }

    // Add next month's dates
    const remainingCells = totalCells - days.length;
    for (let i = 1; i <= remainingCells; i++) {
      const date = moment(props?.currentDate).add(1, "month").date(i);
      const dayAppointments = getAppointmentsForDate(date);
      const isToday = date.isSame(moment(), 'day');
      const filterDayAppointments = filterAppointments(dayAppointments, props?.clientName, props?.empNames);
      const appointmentCount = filterAppointments(dayAppointments, props?.clientName, props?.empNames).length;
      days.push(
        <div key={`next-${i}`} className={`calendar-day-null ${isToday ? 'bg-highlighBlue dark:bg-gray-600' : 'dark:bg-[#1A1F2C]'}`}
          style={{ cursor: filterDayAppointments?.length === 0 ? 'pointer' : 'default' }}>
          <div className={`appointmentDateCount ${isToday ? "dark:bg-gray-600" : "bg-white dark:bg-[#1A1F2C]"}`}>
            <div className={`calendar-day-number light-color ${isToday ? "dark:bg-gray-600" : "bg-white dark:bg-[#1A1F2C]"}`} style={{width : isExpand && isFullScreen ? "81%" : ""}}>{i}</div>
            <div className="appointmentCount"  style={{width : isExpand && isFullScreen ? "19%" : ""}} onClick={() => props?.handleScrollToAppointments(date)}>
              {appointmentCount > 0 && (
                <span>
                  {appointmentCount} {!isMobile ? 'Appts' : ''}
                </span>
              )}
            </div>
          </div>
          {filterDayAppointments?.sort((a, b) => {
            const timeA = a.appointmentDateTime.slice(11, 16);
            const timeB = b.appointmentDateTime.slice(11, 16);
            return timeA.localeCompare(timeB);
          }).map((appointment, index) => {
            const emp = props?.employeeNameList?.find((emp) => emp.userId === appointment.userId);
            return (
              !isMobile ? (
                <div key={index} className="appointment" onClick={() => {
                  setSelectedAppointment(appointment);
                  setIsModalOpen(true);
                }}>
                  {getStatusTag(appointment, emp, props?.alerts)}
                </div>
              ) : null
            );
          })}
        </div>
      );
    }

    return days;
  };


  return (
    <div className="calendar-container-month">
      <div className='mt-5'>
        <div className="calendar-grid-month">
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
            <div key={day} className="weekday-header">
              {day}
            </div>
          ))}
        </div>
        <div className="calendar-grid-month">
          {generateMonthView()}
        </div>
      </div>
    </div>
  );
};

export default MonthView;